import { render, staticRenderFns } from "./mct-tree.vue?vue&type=template&id=07fdd3f0&"
import script from "./mct-tree.vue?vue&type=script&lang=js&"
export * from "./mct-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports